export const proposalFilterStates = [
  'draft',
  'published',
  'archived',
  'template',
  'overview',
];
